import { Container, Divider, Header, SummaryGroup, useAlignments, useSizes } from 'metrix-common3';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import ProfileDwelling from './Dwelling';

const ProfileDwellings = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    const [mode, setMode] = useState('summary');
    const [current, setCurrent] = useState(null);

    // biome-ignore lint/correctness/useExhaustiveDependencies: mount-only init
    useEffect(() => {
        props.doGetPolicy();
    }, []);

    const getDwellings = () => {
        const dwellings = [];

        if (props.policy?.dwellings && props.policy.dwellings.length > 0) {
            props.policy.dwellings.forEach((dwelling) => {
                const option = { code: 'dwelling', value: dwelling.guid };

                let dwellingName = (
                    <FormattedMessage
                        key={dwelling.guid}
                        id='Profile_Dwellings.dwelling'
                        values={{ number: dwelling.number || '' }}
                    />
                );

                if (dwelling.construction?.yearBuilt && dwelling.construction?.type?.value) {
                    dwellingName = `${dwelling.construction.yearBuilt} ${dwelling.construction.type.value}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: dwellingName });

                dwellings.push(option);
            });
        }

        return dwellings;
    };

    const dwellings = getDwellings();
    return (
        <Container>
            {mode === 'summary' && (
                <React.Fragment>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Dwellings.dwellings' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameters([]);
                                props.doExecutePolicyAction({ code: 'CREATEDWELLING' });
                            }}
                            allowEdit
                            editEvent={(dwelling) => {
                                setCurrent(dwelling);
                                setMode('dwelling');
                                props.doReduceParameters([{ code: 'Dwelling', value: dwelling }]);
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(dwelling) => {
                                props.doReduceParameters([{ code: 'Dwelling', value: dwelling }]);
                                props.doExecutePolicyAction({ code: 'DELETEDWELLING' });
                            }}
                            entities={dwellings}
                            icon='home'
                        />
                    </Container>
                </React.Fragment>
            )}
            {mode === 'dwelling' && (
                <ProfileDwelling
                    dwelling={props.policy.dwellings.find((x) => x.guid === current)}
                    dotProp={`dwellings.${props.policy.dwellings.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('summary');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    doReduceParameter={props.doReduceParameter}
                    doExecutePolicyAction={props.doExecutePolicyAction}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
        </Container>
    );
};

export default ProfileDwellings;
